var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page chageggage dataAll-content" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("dataScreening", {
            attrs: {
              propsData: {
                isCountry: false,
                isCurrency: false,
                adChannel: false,
                adPlacement: false
              }
            },
            on: {
              searchChange: _vm.searchChange,
              currencyChange: _vm.currencyChange
            }
          }),
          _vm.rawData.game_mark.indexOf("yjfm") == -1
            ? [
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: {
                          filterable: "",
                          placeholder: _vm.$t("pleaseChoose")
                        },
                        on: { change: _vm.getServer },
                        model: {
                          value: _vm.paramsData.is_prod,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "is_prod", $$v)
                          },
                          expression: "paramsData.is_prod"
                        }
                      },
                      _vm._l(_vm.severlist, function(item) {
                        return _c("el-option", {
                          key: item.label,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: {
                          clearable: "",
                          filterable: "",
                          placeholder: _vm.$t("pleaseSelectServer")
                        },
                        model: {
                          value: _vm.paramsData.server_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "server_id", $$v)
                          },
                          expression: "paramsData.server_id"
                        }
                      },
                      _vm._l(_vm.serverList, function(item) {
                        return _c("el-option", {
                          key: item.serverID,
                          attrs: {
                            label: item.serverName,
                            value: item.serverID
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            : [
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: {
                          filterable: "",
                          placeholder: _vm.$t("pleaseChoose")
                        },
                        on: { change: _vm.envIdChange },
                        model: {
                          value: _vm.paramsData.env_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "env_id", $$v)
                          },
                          expression: "paramsData.env_id"
                        }
                      },
                      _vm._l(_vm.szgmEnv, function(item) {
                        return _c("el-option", {
                          key: item.label,
                          attrs: { label: item.label, value: item.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          placeholder: _vm.$t("serverChannel")
                        },
                        on: { change: _vm.serverChange },
                        model: {
                          value: _vm.server_channel,
                          callback: function($$v) {
                            _vm.server_channel = $$v
                          },
                          expression: "server_channel"
                        }
                      },
                      _vm._l(_vm.serverChannel, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          filterable: "",
                          placeholder: _vm.$t("showTestServer")
                        },
                        on: { change: _vm.serverChannelChange },
                        model: {
                          value: _vm.show_test,
                          callback: function($$v) {
                            _vm.show_test = $$v
                          },
                          expression: "show_test"
                        }
                      },
                      _vm._l(_vm.serverType, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          clearable: "",
                          placeholder: _vm.$t("server")
                        },
                        on: { change: _vm.severChange },
                        model: {
                          value: _vm.paramsData.server_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "server_id", $$v)
                          },
                          expression: "paramsData.server_id"
                        }
                      },
                      _vm._l(_vm.serverListYJ, function(item) {
                        return _c("el-option", {
                          key: item.serverID,
                          attrs: {
                            label: item.serverName,
                            value: item.serverID
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: _vm.$t("roleId") },
                model: {
                  value: _vm.paramsData.role_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "role_id", $$v)
                  },
                  expression: "paramsData.role_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  placeholder: _vm.$t("marketTypePlaceholder")
                },
                model: {
                  value: _vm.paramsData.market_type,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "market_type", $$v)
                  },
                  expression: "paramsData.market_type"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  placeholder: _vm.$t("marketIdPlaceholder")
                },
                model: {
                  value: _vm.paramsData.market_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "market_id", $$v)
                  },
                  expression: "paramsData.market_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: _vm.$t("costLabel") },
                model: {
                  value: _vm.paramsData.cost,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "cost", $$v)
                  },
                  expression: "paramsData.cost"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: _vm.$t("obtainLabel") },
                model: {
                  value: _vm.paramsData.obtain,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "obtain", $$v)
                  },
                  expression: "paramsData.obtain"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: _vm.$t("goodsListLabel") },
                model: {
                  value: _vm.paramsData.goods_list,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "goods_list", $$v)
                  },
                  expression: "paramsData.goods_list"
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.exportdataloading,
                    disabled: !_vm.tableData.length
                  },
                  on: { click: _vm.exportdata }
                },
                [_vm._v(_vm._s(_vm.$t("export")))]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut ", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.searchClick(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.tableData.length
        ? _c(
            "el-table",
            {
              directives: [
                {
                  name: "sticky-table-header",
                  rawName: "v-sticky-table-header",
                  value: 0,
                  expression: "0"
                },
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.reqLoading,
                  expression: "reqLoading"
                }
              ],
              ref: "tableRef",
              attrs: { id: "tableRef", data: _vm.tableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "game", label: _vm.$t("game") }
              }),
              _c("el-table-column", {
                attrs: { prop: "platform", label: _vm.$t("platform") }
              }),
              _c("el-table-column", {
                attrs: { prop: "channel", label: _vm.$t("channel") }
              }),
              _c("el-table-column", {
                attrs: { prop: "pkg", label: _vm.$t("pkg") }
              }),
              _c("el-table-column", {
                attrs: { prop: "ip", label: _vm.$t("ip") }
              }),
              _c("el-table-column", {
                attrs: { prop: "server_id", label: _vm.$t("serverId") }
              }),
              _c("el-table-column", {
                attrs: { prop: "server_name", label: _vm.$t("serverName") }
              }),
              _c("el-table-column", {
                attrs: { prop: "user_id_str", label: _vm.$t("userId") }
              }),
              _c("el-table-column", {
                attrs: { prop: "role_id_str", label: _vm.$t("roleId") }
              }),
              _c("el-table-column", {
                attrs: { prop: "role_name", label: _vm.$t("roleName") }
              }),
              _c("el-table-column", {
                attrs: { prop: "level", label: _vm.$t("level") }
              }),
              _c("el-table-column", {
                attrs: { prop: "market_type", label: _vm.$t("shopTypeLabel") }
              }),
              _c("el-table-column", {
                attrs: { prop: "market_id", label: _vm.$t("shopIdLabel") }
              }),
              _c("el-table-column", {
                attrs: { prop: "cost", label: _vm.$t("costLabel") },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return _vm._l(scope.row.cost, function(item, index) {
                          return _c("div", { key: index }, [
                            _vm._v(
                              " " +
                                _vm._s(item.name) +
                                ":" +
                                _vm._s(item.num) +
                                " "
                            )
                          ])
                        })
                      }
                    }
                  ],
                  null,
                  false,
                  3787914420
                )
              }),
              _c("el-table-column", {
                attrs: { prop: "obtain", label: _vm.$t("obtainLabel") },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return _vm._l(scope.row.obtain, function(item, index) {
                          return _c("div", { key: index }, [
                            _vm._v(
                              " " +
                                _vm._s(item.name) +
                                ":" +
                                _vm._s(item.num) +
                                " "
                            )
                          ])
                        })
                      }
                    }
                  ],
                  null,
                  false,
                  4144308832
                )
              }),
              _c("el-table-column", {
                attrs: { prop: "goods_list", label: _vm.$t("goodsListLabel") },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return _vm._l(scope.row.goods_list, function(
                          item,
                          index
                        ) {
                          return _c("div", { key: index }, [
                            _vm._v(
                              " " +
                                _vm._s(item.name) +
                                ":" +
                                _vm._s(item.num) +
                                " "
                            )
                          ])
                        })
                      }
                    }
                  ],
                  null,
                  false,
                  2941526482
                )
              }),
              _c("el-table-column", {
                attrs: { prop: "ext", label: _vm.$t("extendedParams") }
              }),
              _c("el-table-column", {
                attrs: { prop: "time", label: _vm.$t("time") }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.tableData.length
        ? _c("el-pagination", {
            attrs: {
              layout: "total,sizes, prev, pager, next",
              "current-page": _vm.paramsData.page,
              total: _vm.total,
              page_size: _vm.paramsData.page_size
            },
            on: {
              "current-change": _vm.searchClick,
              "size-change": _vm.sizeChange
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }